@if (toggleSide === 'left') {
  <button
    type="button"
    class="pointer-events-auto absolute -left-5 top-6 z-50 flex h-9 w-5 cursor-pointer items-center justify-center rounded-l-lg bg-indigo500 text-white shadow-md"
    (click)="toggle()"
    [attr.aria-label]="isOpen ? 'Collapse panel' : 'Expand panel'"
  >
    <app-icon-reusable
      [icon]="icon"
      [size]="14"
      [useCurrentColor]="true"
      [classes]="'origin-center transition-transform duration-300 ' + (isOpen ? 'rotate-180' : '')"
    ></app-icon-reusable>
  </button>
} @else {
  <button
    type="button"
    class="pointer-events-auto absolute top-6 z-50 flex h-9 w-5 cursor-pointer items-center justify-center rounded-l-lg bg-indigo500 text-white shadow-md"
    [ngClass]="isOpen ? '-left-5' : 'right-0'"
    (click)="toggle()"
    [attr.aria-label]="isOpen ? 'Collapse panel' : 'Expand panel'"
  >
    <app-icon-reusable
      [icon]="icon"
      [size]="14"
      [useCurrentColor]="true"
      [classes]="'origin-center transition-transform duration-300 ' + (isOpen ? '' : 'rotate-180')"
    ></app-icon-reusable>
  </button>
}

<div
  class="absolute inset-0 flex flex-col border-l border-slate200 bg-white shadow-lg transition-opacity duration-200"
  [class.opacity-0]="!isOpen"
  [class.invisible]="!isOpen"
  [class.pointer-events-none]="!isOpen"
  [class.pointer-events-auto]="isOpen"
>
  <ng-content select="[panel-header]"></ng-content>
  <div class="flex-1 overflow-y-auto p-4">
    <ng-content></ng-content>
  </div>
</div>
